export default (element) => {
  function initPanel() {
    const openBtns = element.querySelectorAll('[data-panel-open]');
    const closeBtns = element.querySelectorAll('[data-panel-close]');
    const panel = element.querySelector('[data-panel]');
    const headerFilters = element.querySelector('[data-filters-header]');
    const html = document.querySelector('html');
    const body = document.querySelector('body');

    openBtns.forEach((btn) =>
      btn.addEventListener('click', () => {
        panel.classList.add('!translate-x-0');
        headerFilters.classList.add('!hidden');
        html.classList.add('h-full', 'overflow-hidden');
        body.classList.add('h-full', 'overflow-hidden');
      }),
    );
    closeBtns.forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        panel.classList.remove('!translate-x-0');
        headerFilters.classList.remove('!hidden');
        html.classList.remove('h-full', 'overflow-hidden');
        body.classList.remove('h-full', 'overflow-hidden');
      }),
    );
  }

  function initChosenFilter() {
    const options = element.querySelectorAll('[data-filter-option]');
    const filteredOptions = [];
    options.forEach((option) => {
      if (filteredOptions.includes(option.name)) return;
      const groupCheckedOptions = [
        ...element.querySelectorAll(`[name="${option.name}"]:checked`),
      ];
      const chosenAmountWrapper = element.querySelector(
        `input + [for="${option.name}"] span`,
      );
      chosenAmountWrapper.innerText =
        groupCheckedOptions.length > 0 ? `(${groupCheckedOptions.length})` : '';
      filteredOptions.push(option.name);
    });
  }
  const updateChosenFilter = () => {
    const options = element.querySelectorAll('[data-filter-option]');
    options.forEach((option) => {
      option.addEventListener('change', (e) => {
        const groupCheckedOptions = [
          ...element.querySelectorAll(
            `[name="${e.currentTarget.name}"]:checked`,
          ),
        ];
        const chosenAmountWrapper = element.querySelector(
          `input + [for="${e.currentTarget.name}"] span`,
        );
        chosenAmountWrapper.innerText =
          groupCheckedOptions.length > 0
            ? `(${groupCheckedOptions.length})`
            : '';
      });
    });
  };
  const renderChosenElement = (name, wrapper, clearBtn, colorHex) => {
    const chosenElement = document.createElement('li');

    chosenElement.className =
      'relative flex items-center h7 block py-1 pl-2.5 bg-core-1 pr-7';
    const span = document.createElement('span');
    span.className =
      'absolute cursor-pointer right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 before:absolute before:bg-gray-900 before:origin-center before:block before:w-2 before:h-[1px] before:rotate-45 before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before: after:absolute after:bg-gray-900 after:origin-center after:block after:w-2 after:h-[1px] after:-rotate-45 after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2';
    if (colorHex) {
      chosenElement.innerHTML = `
          <span class="w-4 h-4 inline-block rounded-full mr-1"
          style="background: ${colorHex}"></span>${name}
        `;
    } else chosenElement.innerText = name;
    chosenElement.appendChild(span);
    clearBtn.classList.remove('!hidden');
    span.addEventListener('click', () => {
      chosenElement.remove();
      const input = document.querySelector(`#${name}`);
      input.click();
      if (wrapper.querySelectorAll('li').length === 0)
        clearBtn.classList.add('!hidden');
    });
    return chosenElement;
  };
  const initFilter = () => {
    const filterBtn = element.querySelector('[data-filter]');
    const filterForm = element.querySelector('[data-filter-form]');
    const chosenOptionsWrapper = element.querySelector('[data-chosen-options]');
    const clearBtn = element.querySelector('[data-clear]');
    const body = document.querySelector('body');

    filterBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      const inputs = filterForm.querySelectorAll(
        `[data-filter-option]:checked`,
      );
      body.classList.add('filter-chosen');
      chosenOptionsWrapper.innerHTML = '';
      inputs.forEach((inp) =>
        chosenOptionsWrapper.appendChild(
          renderChosenElement(
            inp.id,
            chosenOptionsWrapper,
            clearBtn,
            inp.dataset.hex,
          ),
        ),
      );
    });
  };
  const initClearBtn = () => {
    const clearBtns = element.querySelectorAll('[data-clear]');
    const body = document.querySelector('body');
    clearBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const chosenOptionsWrapper = element.querySelector(
          '[data-chosen-options]',
        );
        clearBtns.forEach((button) => {
          if (button.classList.contains('flex'))
            button.classList.add('!hidden');
        });
        body.classList.remove('filter-chosen');
        chosenOptionsWrapper.innerHTML = '';
        const inputs = element.querySelectorAll(`[data-filter-option]:checked`);
        inputs.forEach((inp) => inp.click());
      });
    });
  };

  const revertSortByItems = () => {
    const sortItems = document.querySelectorAll('[data-sort-by-item]');
    sortItems.forEach((item) => {
      item.classList.remove('body-2--medium');
      item.classList.remove('underline');
      item.classList.add('body-2');
    });
  };

  const initSortBy = () => {
    const sortByDropdown = document.querySelector('[data-sort-by-dropdown]');
    if (!sortByDropdown) return;

    const sortByLabel = document.querySelector('[data-sort-by-label]');
    const sortplpArrow = document.querySelector('[data-sort-by-arrow]');
    const sortplpArrowIcon = sortplpArrow.querySelector('svg');
    const sortItems = document.querySelectorAll('[data-sort-by-item]');
    const sortActiveItem = document.querySelector('[data-sort-by-active-item]');

    const toggleSortBy = () => {
      if (sortByDropdown.classList.contains('hidden')) {
        sortByDropdown.classList.remove('hidden');
        sortplpArrowIcon.classList.add('rotate-180');
        sortplpArrow.classList.add('mt-[3px]');
      } else {
        sortByDropdown.classList.add('hidden');
        sortplpArrowIcon.classList.remove('rotate-180');
        sortplpArrow.classList.remove('mt-[3px]');
      }
    };

    sortByLabel.addEventListener('click', () => {
      toggleSortBy();
    });

    sortItems.forEach((item) => {
      item.addEventListener('click', () => {
        revertSortByItems();
        item.classList.remove('body-2');
        item.classList.add('body-2--medium');
        item.classList.add('underline');
        sortActiveItem.innerHTML = item.innerHTML;
        toggleSortBy();
      });
    });
  };

  const calculateFilterScroll = () => {
    const windowWidth = window.innerWidth;
    const headerHeight =
      windowWidth > 1024
        ? document.querySelector('#shopify-section-header')?.offsetHeight
        : document.querySelector('[data-header-links]')?.offsetHeight;
    const wrapper = element.querySelector('[data-results-wrapper]');
    if (!wrapper) return;
    document.addEventListener('scroll', () => {
      if (
        window.scrollY >=
        wrapper.offsetTop + wrapper.offsetHeight - headerHeight
      ) {
        wrapper.classList.add('fixed', 'p-5', 'lg:px-10', 'left-0');
        wrapper.style.top = `${headerHeight}px`;
      } else {
        wrapper.classList.remove('fixed', 'p-5', 'left-0', 'lg:px-10');
        wrapper.style.top = `auto`;
      }
    });
  };

  initPanel();
  initChosenFilter();
  updateChosenFilter();
  initFilter();
  initClearBtn();
  initSortBy();
  calculateFilterScroll();
};
